import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import styles from './LoadingState.module.css';

type LoadingStateProps = {
  message?: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
  compact?: boolean;
  variant?: 'default' | 'overlay';
};

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = '로딩 중...',
  size = 48,
  className,
  style,
  compact = false,
  variant = 'default',
}) => {
  const getContainerClass = () => {
    if (compact) return styles.loadingStateCompact;
    if (variant === 'overlay') return styles.loadingStateOverlay;
    return styles.loadingState;
  };

  return (
    <div className={`${getContainerClass()} ${className || ''}`} style={style}>
      <div className={styles.spinnerContainer}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: size }} spin className={styles.spinnerIcon} />} />
        {message && <div className={styles.loadingMessage}>{message}</div>}
      </div>
    </div>
  );
};
